import { Search, Calendar, Download, RefreshCw } from "lucide-react";

export default function FilterBar({
  q,
  setQ,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
  status,
  setStatus,
  statuses,
  onRefresh,
  onExport,
  count,
  searchPlaceholder = "Search by name, email, phone…",
}) {
  return (
    <div className="rounded-xl border border-white/10 bg-[#121212] p-4 flex flex-wrap gap-3 items-end">
      <div className="flex-1 min-w-[220px]">
        <label className="block text-[10px] font-mono uppercase tracking-[0.25em] text-neutral-500 mb-1.5">
          Search
        </label>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-500" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder={searchPlaceholder}
            data-testid="filter-search"
            className="w-full bg-[#1a1a1a] border border-white/10 text-white placeholder-neutral-500 rounded-md pl-10 pr-3 py-2 text-sm focus:outline-none focus:border-[#dc2626]"
          />
        </div>
      </div>

      <div>
        <label className="block text-[10px] font-mono uppercase tracking-[0.25em] text-neutral-500 mb-1.5">
          From
        </label>
        <div className="relative">
          <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-neutral-500 pointer-events-none" />
          <input
            type="date"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
            data-testid="filter-date-from"
            className="bg-[#1a1a1a] border border-white/10 text-white rounded-md pl-9 pr-3 py-2 text-sm focus:outline-none focus:border-[#dc2626]"
          />
        </div>
      </div>

      <div>
        <label className="block text-[10px] font-mono uppercase tracking-[0.25em] text-neutral-500 mb-1.5">
          To
        </label>
        <div className="relative">
          <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-neutral-500 pointer-events-none" />
          <input
            type="date"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
            data-testid="filter-date-to"
            className="bg-[#1a1a1a] border border-white/10 text-white rounded-md pl-9 pr-3 py-2 text-sm focus:outline-none focus:border-[#dc2626]"
          />
        </div>
      </div>

      {statuses && (
        <div>
          <label className="block text-[10px] font-mono uppercase tracking-[0.25em] text-neutral-500 mb-1.5">
            Status
          </label>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            data-testid="filter-status"
            className="bg-[#1a1a1a] border border-white/10 text-white rounded-md px-3 py-2 text-sm focus:outline-none focus:border-[#dc2626]"
          >
            <option value="all">All</option>
            {statuses.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="flex items-center gap-2 ml-auto">
        {typeof count === "number" && (
          <span className="text-xs font-mono text-neutral-500 mr-2">
            {count} record{count !== 1 ? "s" : ""}
          </span>
        )}
        <button
          onClick={onRefresh}
          data-testid="filter-refresh"
          className="inline-flex items-center gap-1.5 border border-white/15 hover:bg-white/5 text-neutral-200 rounded-md px-3 py-2 text-sm"
        >
          <RefreshCw className="h-3.5 w-3.5" /> Refresh
        </button>
        {onExport && (
          <button
            onClick={onExport}
            data-testid="filter-export"
            className="inline-flex items-center gap-1.5 bg-[#dc2626] hover:bg-[#ef4444] text-white rounded-md px-3 py-2 text-sm font-semibold"
          >
            <Download className="h-3.5 w-3.5" /> Export CSV
          </button>
        )}
      </div>
    </div>
  );
}
